import Chip from '@mui/material/Chip';
import { statusColors } from 'utils/statusColors';
import { DocumentStatus } from 'services/documents/entities';

interface DocumentStatusChipProps {
  documentStatus: DocumentStatus;
}

const STATUS_DISPLAY: Record<DocumentStatus, { label: string; backgroundColor: string }> = {
  [DocumentStatus.DRAFT]: { label: 'Draft', backgroundColor: statusColors[DocumentStatus.DRAFT] },
  [DocumentStatus.SENT]: { label: 'Sent', backgroundColor: statusColors[DocumentStatus.SENT] },
  [DocumentStatus.VIEWED]: { label: 'Viewed', backgroundColor: statusColors[DocumentStatus.VIEWED] },
  [DocumentStatus.AWAITING_SIGNATURE]: { label: 'Awaiting Signature', backgroundColor: statusColors[DocumentStatus.AWAITING_SIGNATURE] },
  [DocumentStatus.AWAITING_APPROVAL]: { label: 'Awaiting Approval', backgroundColor: statusColors[DocumentStatus.AWAITING_APPROVAL] },
  [DocumentStatus.APPROVED]: { label: 'Approved', backgroundColor: statusColors[DocumentStatus.APPROVED] },
  [DocumentStatus.LOST]: { label: 'Lost', backgroundColor: statusColors[DocumentStatus.LOST] },
  [DocumentStatus.WON]: { label: 'Won', backgroundColor: statusColors[DocumentStatus.WON] },
};

export const DocumentStatusChip = ({ documentStatus }: DocumentStatusChipProps) => {
  const { label, backgroundColor } = STATUS_DISPLAY[documentStatus];

  return (
    <Chip
      variant="filled"
      sx={{
        marginLeft: 1,
        color: 'text.primary',
        backgroundColor,
      }}
      label={label}
      size="small"
    />
  );
};
